import { render, staticRenderFns } from "./VarianceColumnView.vue?vue&type=template&id=38a8ede8&scoped=true"
import script from "./VarianceColumnView.vue?vue&type=script&lang=js"
export * from "./VarianceColumnView.vue?vue&type=script&lang=js"
import style0 from "./VarianceColumnView.vue?vue&type=style&index=0&id=38a8ede8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8ede8",
  null
  
)

export default component.exports